<template>
  <!-- 机器人问题列表 卡片样式 -->
  <div class="question-card" v-if="item.type === 7 && config.display === 2">
    <div class="question-card__header flex flex-between">
      <div class="question-card__title">{{ styleConfig.guideWords }}：</div>
      <div
        class="question-card__refresh flex flex-item-center"
        @click="handleChangeQuestion(item.quick_replies)"
        v-if="item.quick_replies.length > 5"
      >
        <i class="iconfont icon-refresh" />
        换一换
      </div>
    </div>
    <div
      class="question-card__item"
      :style="{ color: textColor }"
      @click="handleSendMsg(item.type, i)"
      v-for="i in item.quick_replies.slice(queIndex, queIndex + 5)"
      :key="i.id"
    >
      {{ i.label }}
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, defineEmits, ref } from 'vue'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  item: { type: Object, default: () => {} },
  showType: { type: Number, default: 1 }
})
const emit = defineEmits(['send'])
const config = computed(() => {
  if (props.styleConfig && Object.keys(props.styleConfig).length > 0) {
    return props.styleConfig
  } else {
    return {
      display: 1,
      guideWords: '',
      themeColor: '#3571F0'
    }
  }
})
const textColor = computed(() => {
  return config.value.themeColor || '#3571F0'
  // return props.showType === 1 ? '#3571F0' : config.value.themeColor
})
// 换一换置顶问题
const queIndex = ref(0)
const handleChangeQuestion = (arr) => {
  if (queIndex.value + 5 < arr.length) {
    queIndex.value += 5
  } else {
    queIndex.value = 0
  }
}
// 快捷点击
const handleSendMsg = (type, data) => {
  emit('send', type, data)
}
</script>
<style lang="less" scoped>
.question-card {
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 5px;
  max-width: 300px;
  word-break: break-all;
  background-color: #ffffff;
  border-radius: 5px;
  margin-left: -60px;
  margin-top: -10px;
  &__header {
    padding: 10px 15px;
    border-bottom: 1px solid #ececec;
  }
  &__title {
    color: #227fff;
  }
  &__refresh {
    font-size: 12px;
    color: #999999;
    cursor: pointer;
    > i {
      margin-right: 4px;
    }
  }
  &__item {
    padding: 8px 0;
    margin: 0 10px;
    cursor: pointer;
    border-bottom: 1px solid #ececec;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
